<template>
  <div class="c data-editor">
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          label="Name"
          v-model="values.name"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-select
          :items="items"
          label="Typ"
          item-text="label"
          item-value="value"
          color="primary"
          v-model="values.type"
          ref="type"
        ></v-select>
      </v-flex>
      <v-flex xs12>
        <v-select
          :items="sensorModels"
          label="Sensor-Modell"
          item-text="label"
          item-value="value"
          color="primary"
          v-model="values.sensorModel"
          ref="sensorModel"
        ></v-select>
      </v-flex>
      <v-flex>
        <v-btn
          class="no-spacing"
          color="error"
          @click="deleteParkingSpace"
        >Parkplatz löschen</v-btn>
      </v-flex>
      <v-flex class="text-align-right">
        <v-btn
          class="no-spacing"
          flat
          color="primary"
          @click="updateShape"
        >Fläche bearbeiten</v-btn>
        <v-btn class="no-spacing" color="primary" @click="updateData">Speichern</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'data-editor',

  props: {
    type: {
      type: String,
      required: true,
    },
    sensorModel: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      items: [
        { label: 'Parkplatz für E-Autos', value: 'charging' },
        { label: 'Behindertenparkplatz', value: 'handicapped' },
        { label: 'Parkplatz', value: 'normal' },
      ],
      sensorModels: [
        { label: 'Bosch', value: 'bosch' },
      ],
      values: {
        sensorModel: '',
        type: '',
        name: '',
      },
    };
  },

  watch: {
    type: {
      immediate: true,
      handler(newVal) {
        this.values.type = newVal;
      },
    },
    sensorModel: {
      immediate: true,
      handler(newVal) {
        this.values.sensorModel = newVal;
      },
    },
    name: {
      immediate: true,
      handler(newVal) {
        this.values.name = newVal;
      },
    },
  },

  methods: {
    deleteParkingSpace() {
      this.$emit('delete');
    },
    updateData() {
      this.$emit('save', {
        sensor_model: this.values.sensorModel,
        type: this.values.type,
        name: this.values.name,
      });
    },
    updateShape() {
      this.$emit('update-shape');
    },
  },
};
</script>
